import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["Layouts"];
import { SearchRecommendationLayout } from './SearchRecommendation.layout';
import { createPremiumModule, ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
import React from 'react';
import { SearchRecommendationList } from './SearchRecommendationList';
import { SearchRecommendation } from './SearchRecommendation';
export const SearchRecommendationModule = createPremiumModule('searchRecommendation', [
// getPremiumSingleton caches this context on window first-writer-wins and the merge keeps only
// the winning base's keys, so a stale bundle drops any slot it predates and SDK.Layouts.<Slot>
// renders `undefined`. ⚠️ Bump v2 → v3 whenever SearchRecommendationLayout gains or loses a slot
// (SearchRecommendation.module.spec.ts guards this).
ModuleExtensions.customComponentsExtension(SearchRecommendationLayout, 'Layouts', {
  version: 2,
  uniqueGlobalKey: 'searchRecommendation-v2'
})], () => ({
  SDK: {
    Components: {
      SearchRecommendationList,
      SearchRecommendation
    }
  }
}));
export const RecommendationList = _ref => {
  let _ref$Layouts = _ref.Layouts,
    Layouts = _ref$Layouts === void 0 ? {} : _ref$Layouts,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SearchRecommendationModule.Provider, {
    Layouts: {
      customConfiguration: Layouts
    }
  }, /*#__PURE__*/React.createElement(SearchRecommendationModule.SDK.Components.SearchRecommendationList, props));
};
//# sourceMappingURL=SearchRecommendation.module.js.map